import { Icon, TextLink, TextPassage } from '@petsmart-ui/sparky';
import type { LinkBlockProps } from '../types';

import './LinkBlock.scss';

export default function LinkBlock({ question, answers, iconName, style }: LinkBlockProps) {
    return (
        <div className="tile4-link-block" style={style}>
            <Icon name={iconName} size="md" />
            <div className="tile4-link-block__heading">
                <TextPassage size="lg">{question}</TextPassage>
                {answers.map(({ link, actionText, sysId }) => (
                    <TextLink href={link.webUrl} key={sysId}>
                        {actionText}
                    </TextLink>
                ))}
            </div>
        </div>
    );
}
